<template>
<div class="chapter">
<div class="inner_page">
<p class="frn"><span class="textStyle7">CAST OF CHARACTERS</span></p>
<table class="table">
<tbody><tr>
<td align="left" valign="top"><span class="textStyle5">Roderick Alleyn</span></td>
<td align="right" valign="top"><span class="textStyle8">Chief Detective-Inspector, CID, New Scotland Yard</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Agatha Troy</span></td>
<td align="right" valign="top"><span class="textStyle8">His Wife</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Miss Truebody</span></td>
<td align="right" valign="top"><span class="textStyle8">Their fellow-passenger</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Dr Claudel</span></td>
<td align="right" valign="top"><span class="textStyle8">A French physician</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Raoul Milano</span></td>
<td align="right" valign="top"><span class="textStyle8">Of Roqueville, Owner-driver</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Dr Ali Baradi</span></td>
<td align="right" valign="top"><span class="textStyle8">A surgeon</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Mahomet</span></td>
<td align="right" valign="top"><span class="textStyle8">His servant</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Mr Oberon</span></td>
<td align="right" valign="top"><span class="textStyle8">Of the Château de la Chèvre d’Argent</span></td>
</tr>
<tr>
<td align="left" class="space" valign="top"><span class="textStyle5">Ginny Taylor<br/>
      Robin Herrington<br/>
      Carbury Glande<br/>
      Annabella Wells</span></td>
<td align="right" class="space" valign="top"><span class="textStyle8">His guests</span></td>
</tr>
<tr>
<td align="left" class="space" valign="top"><span class="textStyle5">Teresa</span></td>
<td align="right" class="space" valign="top"><span class="textStyle8">The fiancée of Raoul</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">M. Dupont</span></td>
<td align="right" valign="top"><span class="textStyle8">Of the Sûreté. Acting Commissaire at the Préfecture, Roqueville</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">M. Callard</span></td>
<td align="right" valign="top"><span class="textStyle8">Managing Director of the Compagnie Chimique des Alpes Maritimes</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">M. &amp; Madame Milano</span></td>
<td align="right" valign="top"><span class="textStyle8">The parents of Raoul</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">Marie</span></td>
<td align="right" valign="top"><span class="textStyle8">A maker of figurines</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">M. Malaquin</span></td>
<td align="right" valign="top"><span class="textStyle8">Proprietor of the Hôtel Royal</span></td>
</tr>
<tr>
<td align="left" valign="top"><span class="textStyle5">P. E. Garbel</span></td>
<td align="right" valign="top"><span class="textStyle8">A chemist</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?7b3b2640